import React from "react";


function ScaleFieldRenderer(props) {
  const config = props.field?.config || {};
  const min = typeof config.min === "number" ? config.min : 1;
  const max = typeof config.max === "number" ? config.max : 10;
  const anchorLow = typeof config.anchor_low === "string" ? config.anchor_low : "";
  const anchorHigh = typeof config.anchor_high === "string" ? config.anchor_high : "";
  const lowThreshold =
    typeof config.low_threshold === "number" ? config.low_threshold : null;

  const selected =
    props.value && typeof props.value.number === "number" ? props.value.number : null;

  const values = [];
  for (let v = min; v <= max; v++) values.push(v);

  const handleSelect = (v) => {
    if (props.disabled) return;
    if (v === selected) {
      props.onChange(null);
    } else {
      props.onChange({ number: v });
    }
  };

  const isLow = selected != null && lowThreshold != null && selected < lowThreshold;

  return (
    <div>
      <div className="flex flex-wrap gap-2 items-center">
        {values.map((v) => {
          const isSelected = v === selected;
          const baseClasses =
            "w-9 h-9 rounded-full text-sm font-medium flex items-center justify-center transition-colors border";
          let stateClasses;
          if (isSelected) {
            stateClasses = isLow
              ? "bg-rose-600 border-rose-600 text-white"
              : "bg-violet-600 border-violet-600 text-white";
          } else {
            stateClasses = props.disabled
              ? "bg-slate-50 border-slate-200 text-slate-400 cursor-not-allowed"
              : "bg-white border-slate-300 text-slate-700 hover:border-violet-400";
          }
          return (
            <button
              key={v}
              type="button"
              onClick={() => handleSelect(v)}
              disabled={props.disabled}
              className={`${baseClasses} ${stateClasses}`}
            >
              {v}
            </button>
          );
        })}
      </div>

      {(anchorLow || anchorHigh) && (
        <div className="flex justify-between mt-2 text-xs text-slate-500">
          <span>{min}: {anchorLow}</span>
          <span>{max}: {anchorHigh}</span>
        </div>
      )}

      {selected != null && (
        <div className="mt-3 text-sm">
          <span className="text-slate-600">Selected: </span>
          <span
            className={`font-semibold ${
              isLow ? "text-rose-600" : "text-slate-900"
            }`}
          >
            {selected}
          </span>
          {isLow && (
            <span className="ml-2 inline-flex items-center bg-rose-50 border border-rose-300 text-rose-700 text-xs font-medium px-2 py-0.5 rounded-md">
              Low
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default ScaleFieldRenderer;
